const app = {
    WHATSAPP_NUMBER: "8217639080" // Replace with your actual WhatsApp number
};

const sendToWhatsApp = (messageType, tripId, vehicleNumber, vehicleName, tripDate, startTime, endTime) => {
    const phoneNumber = app.WHATSAPP_NUMBER;
    let message = "";

    switch (messageType.toUpperCase()) {
        case 'PAYMENTISSUE':
            message = messagePaymentIssue(tripId, vehicleNumber, vehicleName, tripDate, startTime, endTime);
            break;
        case 'CHATWITHUS':
            message = messageChatWithUs(tripId, vehicleNumber, vehicleName, tripDate, startTime, endTime);
            break;
        case 'LOSTITEM':
            message = messageLostItem(tripId, vehicleNumber, vehicleName, tripDate, startTime, endTime);
            break;
        case 'TECHNICALSUPPORT':
            message = messageTechnicalSupport(tripId, vehicleNumber, vehicleName, tripDate, startTime, endTime);
            break;
        case 'GENERALSUPPORT':
            message = messageGeneralSupport();
            break;
        case 'GENERALFEEDBACK':
            message = messageGeneralFeedback();
            break;
        default:
            message = messageDefault(tripId, vehicleNumber, vehicleName, tripDate, startTime, endTime);
            break;
    }

    const encodedMessage = encodeURIComponent(message);
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

    window.open(whatsappURL, '_blank');
};

// Message Templates
const messagePaymentIssue = (tripId, vehicleNumber, vehicleName, tripDate, startTime, endTime) => {
    return `Hi Cruze Team,\n\nI have an issue with the payment, can you please assist?\nHere are the trip details for your quick information:\n\n*Trip:* ${tripId} dated *${tripDate}*\n*Cruze:* ${vehicleName}\n*Cruze Number:* ${vehicleNumber}`;
};

const messageChatWithUs = (tripId, vehicleNumber, vehicleName, tripDate, startTime, endTime) => {
    return `Hi Cruze Team,\n\nI'd like to chat with the Cruze support team.\nHere are the trip details:\n\n*Trip:* ${tripId} dated *${tripDate}*\n*Cruze:* ${vehicleName}\n*Cruze Number:* ${vehicleNumber}`;
};

const messageLostItem = (tripId, vehicleNumber, vehicleName, tripDate, startTime, endTime) => {
    return `Hi Cruze Team,\n\nI lost my item during the trip. Please help me find it.\nHere are the trip details:\n\n*Trip:* ${tripId} dated *${tripDate}*\n*Cruze:* ${vehicleName}\n*Cruze Number:* ${vehicleNumber}`;
};

const messageDefault = (tripId, vehicleNumber, vehicleName, tripDate, startTime, endTime) => {
    return `Hi Cruze Team,\n\nI have some queries regarding my trip.\nHere are the trip details:\n\n*Trip:* ${tripId} dated *${tripDate}*\n*Cruze:* ${vehicleName}\n*Cruze Number:* ${vehicleNumber}`;
};

const messageTechnicalSupport = (tripId, vehicleNumber, vehicleName, tripDate, startTime, endTime) => {
    return `Hi Cruze Team,\n\nI have a technical issue with my trip. Can you please assist soon?\nHere are the trip details:\n\n*Trip:* ${tripId} dated *${tripDate}*\n*Cruze:* ${vehicleName}\n*Cruze Number:* ${vehicleNumber}`;
};

const messageGeneralSupport = () => {
    return `Hi Cruze Team,\n\nI would like to talk to you. Please call me back.`;
};

const messageGeneralFeedback = () => {
    return `Hi Cruze Team,\n\nThanks for showing your interest in providing us with your valuable feedback.\nPlease write your feedback below this line.\n\n--------------------`;
};

export default sendToWhatsApp;
